import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

export function useUser(userId: string | undefined) {
  return useQuery({
    queryKey: [...queryKeys.user(userId!)],
    queryFn: () => api.getUser(userId!),
    enabled: !!userId,
  });
}
